<template>
  <div class="info-area">
    <div class="test-text">
      <SessionGuidelines />
    </div>
  </div>
</template>

<script>
import SessionGuidelines from "./InfoPages/SessionGuidelines.vue";

export default {
  name: "InfoArea",
  components: {
    SessionGuidelines,
  },
};
</script>

<style scoped>
.info-area {
  margin: 0 auto;
  border-radius: 12px;
  background-color: hsl(0deg 0% 100%);
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(62 62 62 / 10%) 0px 3px 6px, rgb(193 193 193 / 20%) 0px 9px 24px;
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  width: 700px;
  height: unset;
  box-sizing: border-box;
  /* margin-top: 80px; */
  margin-top: 85px;
  margin-left: 60px;
  margin-right: 20px;
  padding: 0px 50px;
  padding-top: 30px;
  overflow-y: scroll;
}
.info-area-title {
  font-size: 34px;
  margin-top: 40px;
  margin-left: 60px;
}

.info-modal p,
.info-modal h1,
.info-modal h2,
.info-modal h3,
.info-modal h4,
.info-modal h5 {
  margin-top: 20px !important;
}

.info-modal p {
  line-height: 22px;
}

.info-modal p,
.info-modal h1,
.info-modal h2,
.info-modal h3,
.info-modal h4,
.info-modal h5,
.info-modal pre {
  font-family: "Nunito" !important;
}

.info-modal h3 {
  font-size: 23px;
  margin-top: 30px !important;
}

.info-modal ul {
  margin: 10px 0px;
}

.info-modal li {
  list-style: disc;
  margin-left: 40px;
  padding: 8px 0px;
}

/*! CSS Used from: Embedded ; media=screen */
@media screen {
  .info-modal:after,
  .info-modal:before {
    box-sizing: border-box;
  }
  .info-modal strong {
    font-weight: bolder;
  }
  .info-modal pre {
    font-size: 1em;
  }

  .info-modal h2,
  .info-modal h3,
  .info-modal h4,
  .info-modal h5 {
    font-weight: 800;
    color: #2e2e2e;
    letter-spacing: -0.5px;
    line-height: 1.1;
    margin: 0;
  }
  .info-modal h2 {
    font-size: 3rem;
  }
  .info-modal h3 {
    font-size: 2rem;
  }
  .info-modal p {
    margin: 0;
  }
  .info-modal strong {
    font-weight: 800;
  }
  .info-modal a {
    color: #065af9;
    text-decoration: underline;
  }
  .info-modal a {
    outline: 0;
    transition: color 0.2s linear;
  }
  .info-modal a:focus,
  .info-modal a:hover {
    text-decoration: none;
  }
  .info-modal pre {
    font-size: 1.4rem;
    margin: 0;
    background-color: #fcfcfe;
    border: 1px solid #e6eefe;
    padding: 20px;
    border-radius: 3px;
    overflow: auto;
  }
}
/*! CSS Used from: https://getterms.io/dist/css/style.css?v=1625129748 ; media=screen */
@media screen {
  .info-modal:after,
  .info-modal:before {
    box-sizing: inherit;
  }
  .info-modal strong {
    font-weight: bolder;
  }
  .info-modal pre {
    font-size: 1em;
  }
  .info-modal h2,
  .info-modal h3,
  .info-modal h4,
  .info-modal h5 {
    font-weight: 700;
    color: #2e2e2e;
    letter-spacing: -0.5px;
    line-height: 1.1;
    margin: 0;
  }
  .info-modal h2 {
    font-size: 3rem;
  }
  .info-modal h3 {
    font-size: 2rem;
  }
  .info-modal p {
    margin: 0;
  }
  .info-modal strong {
    font-weight: 800;
  }
  .info-modal a {
    color: #065af9;
    text-decoration: underline;
  }
  .info-modal a {
    outline: 0;
    transition: color 0.2s linear;
  }
  .info-modal a:focus,
  .info-modal a:hover {
    text-decoration: none;
  }
  .info-modal pre {
    font-size: 1.4rem;
    margin: 0;
    background-color: #fcfcfe;
    border: 1px solid #e6eefe;
    padding: 20px;
    border-radius: 3px;
    overflow: auto;
  }
}
/*! CSS Used from: https://getterms.io/dist/css/print.css ; media=print */
@media print {
  .info-modal a,
  .info-modal div,
  .info-modal h2,
  .info-modal h3,
  .info-modal h4,
  .info-modal h5,
  .info-modal li,
  .info-modal p,
  .info-modal pre,
  .info-modal strong,
  .info-modal ul {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: initial;
  }
  .info-modal ul {
    list-style: none;
  }
  .info-modal p,
  .info-modal ul {
    margin: 0 0 20px;
  }
  .info-modal ul {
    padding: 0 0 0 2.5em;
  }
  .info-modal h2,
  .info-modal h3,
  .info-modal h4,
  .info-modal h5 {
    font-weight: 400;
  }
  .info-modal h2 {
    font-size: 35px;
    line-height: 40px;
    margin-bottom: 10px;
  }
  .info-modal h3 {
    font-size: 28px;
    line-height: 34px;
    margin-bottom: 8px;
  }
  .info-modal h4 {
    font-size: 21px;
    line-height: 30px;
    margin-bottom: 4px;
  }
  .info-modal h5 {
    font-size: 17px;
    line-height: 24px;
  }
  .info-modal p {
    margin: 0 0 20px;
  }
  .info-modal strong {
    font-weight: 700;
  }
  .info-modal a {
    color: #333;
    text-decoration: underline;
    outline: 0;
  }
  .info-modal p a {
    line-height: inherit;
  }
  .info-modal ul {
    margin-bottom: 20px;
  }
  .info-modal ul {
    list-style: none outside;
  }
  .info-modal li {
    line-height: 18px;
    margin-bottom: 12px;
  }
}

.test-text {
  padding: 0px 10px;
  padding-top: 10px;
}
</style>
